<template>
  <div class="chartswrapper">
    <div id="chart" :style="{width:chartsWidth+'px',height:chartHeight+'px'}"></div>
  </div>
</template>

<script>
  let echarts = require('echarts/lib/echarts')
  require('echarts/lib/chart/line')
  require("echarts/lib/component/tooltip");
  require("echarts/lib/component/dataZoom");
  require("echarts/lib/component/legend");
  require('echarts/theme/macarons');
  import {formatMoney} from "../../../../utils/format";

  export default {
    name: "Charts",
    data() {
      return {
        chartHeight: 0,
        chartsWidth: 0,
        baodiGop:0,
      }
    },
    props:{
      pageData: {
        type: Object,
        default: null
      }
    },
    watch:{
      pageData(value){
        if(!value) {
          return
        }
        if(value.isZo===1){
          this.setChartsZo()
        }
        else {
          this.setChartsNotZo()
        }
      }

    },
    mounted() {
      this.setWH()
      this.$nextTick(()=>{
      })

    },
    methods: {
      setWH() {
        let w = document.getElementsByClassName('chartswrapper')
        if (w.length > 0) {
          let h = w[0]
          this.chartHeight = Number(window.getComputedStyle(h).height.slice(0, -2))
          this.chartsWidth = Number(window.getComputedStyle(h).width.slice(0, -2))
        }
      },
      setChartsZo() {
        if(!this.pageData.reachRatios){
          return
        }
        let lineChart = echarts.init(document.getElementById('chart'), 'macarons');

        let xAxis=[]
        let data=[]
        this.pageData.reachRatios.forEach((ele,index)=>{
          xAxis.push(ele.dateTime)

          if(index===0){
            data.push(ele.reachRatio)
          }
          else {
            data.push(+((data[index-1]+ele.reachRatio).toFixed(4)))

          }
        })
        let option = {
          dataZoom: [
            {
              type: 'inside',
            }
          ],
          grid:{
            // show:true,
            // left:10,
            // bottom:0

          },
          tooltip: {
            trigger: 'axis',
            // formatter:'{a}:{c}',

            formatter: function (params) {
              // params.sort((p1,p2)=>{
              //   return p2.value-p1.value
              // })
              let ret=params[0].name+'<br>'
              params.forEach(ele => {
                ret += '<p style="vertical-align: top;line-height: 1;margin-bottom: 6px">' +'<span style="vertical-align:top;display: inline-block;width: 14px;height: 14px;border-radius:7px;background-color:' +ele.color+' "> </span>'
                  +'<span style="vertical-align: top">'+ (ele.value * 100).toFixed(2) + '%' + '\n'  +'</span></p>'
              })
              return ret

            }
          },
          xAxis: {
            type: 'category',
            data: xAxis
          },
          yAxis: {
            type: 'value',
            name:'GOP达成率',
            axisLabel:{
              formatter:function (value) {
                return value*100 +'%'
              }
            }
          },
       
          visualMap: {
            pieces: [
              {gt:0,lte:1,color:'#3FA7DC'},
              {gt:1,color:'rgb(253,133,26)'}
            ],
             bottom:0,
             left:'center',
             orient:'horizontal',
            formatter: function (value, value2) {
              console.log(value,value2)
              if(value2 === 1){
                return '未达成'
              } else{
                return '已达成'
              }
            },
          },
          series: [{
            data: data,
            type: 'line',
            smooth: true
          }]
        };
        lineChart.clear()
        lineChart.setOption(option)
      },
      rmoney(s)
        {
        return parseFloat(s.replace(/[^\d\.-]/g, ""));
        },
      setChartsNotZo(){
        this.baodiGop = this.rmoney(this.pageData.firstLine[0].value);
        if(!this.pageData.reachRatios){
          return

        }
        let lineChart = echarts.init(document.getElementById('chart'), 'macarons');

        let xAxis=[]
        let data=[]
        this.pageData.reachRatios.forEach((ele,index)=>{
          xAxis.push(ele.dateTime)

          if(index===0){
            data.push(ele.reachValue)
          }
          else {
            data.push(+((data[index-1]+ele.reachValue).toFixed(2)))

          }
        })
        let option = {
          dataZoom: [
            {
              type: 'inside',
            }
          ],
          grid:{
            bottom:80,
          },
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              // params.sort((p1,p2)=>{
              //   return p2.value-p1.value
              // })
              let ret=params[0].name+'<br>'
              params.forEach(ele => {
                ret += '<p style="vertical-align: top;line-height: 1;margin-bottom: 6px">' +'<span style="vertical-align:top;display: inline-block;width: 14px;height: 14px;border-radius:7px;background-color:' +ele.color+' "> </span>'
                  +'<span style="vertical-align: top">'+ formatMoney(ele.value) + '\n'  +'</span></p>'
              })
              return ret

            }

          },
          xAxis: {
            type: 'category',
            data: xAxis
          },
          yAxis: {
            type: 'value',
            name:'GOP',
          },
          visualMap: {
            pieces: [
              {gt:0,lte:this.baodiGop,color:'#3FA7DC'},
              {gt:this.baodiGop,color:'rgb(253,133,26)'}
            ],
            bottom:0,
            left:'center',
            orient:'horizontal',
            formatter:  (value, value2) => {
              if(value2 === this.baodiGop){
                return '未达成'
              } else{
                return '已达成'
              }
            },
          },
          series: [{
            data: data,
            type: 'line',
            smooth: true
          }]
        };
        lineChart.clear()
        lineChart.setOption(option)
      }
    }
  }
</script>

<style scoped>
  .chartswrapper {
    width: 100%;
    height: 100%;
  }

  #chart {
    /*background-color: lightpink;*/
  }

</style>
